import { Box, FormControlLabel, styled } from "@mui/material";

export const StyledCard = styled(Box)(() => ({
    backgroundColor: '#FFFFFF',
    padding: '20px',
    borderRadius: '8px',
    border: '1px solid #E9E9E9',
    width: '100%'
}));

export const QuickFilterBox = styled(Box)(({ highlighted }) => ({
    borderRadius: "8px",
    border: "1px solid #FFFFFF",
    borderColor: highlighted ? "#6D72F6" : "#FFFFFF",
    boxShadow: "2px 2px 4px 0px rgba(151, 151, 151, 0.25)",
    padding: "7px 12px",
    backgroundColor: highlighted ? "#F7F7FF" : "#FFFFFF",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  }));

export const ActionCheckLabel = styled(FormControlLabel)(({ theme }) => ({
    display: "flex",
    alignItems: 'center',
    marginLeft: 0,

    ".MuiButtonBase-root": {
      padding: 0,
    },

    ".MuiCheckbox-root": {
      padding: 0,
      color: "#A2A2A2 !important",

      "&.Mui-checked": {
        color: "#6D72F6 !important",
      },
      "&.Mui-disabled": {
        color: "#A2A2A2 !important",
      },
    },

    ".MuiSvgIcon-root": {
      width: "20px",
      height: "20px",
    },
}));
